import * as React from 'react';

import * as style from './style.css';

export const Cards = (props: React.PropsWithChildren<{}>) => {
  return <div className={style['container']}>{props.children}</div>;
};
